export default __webpack_public_path__ + "static/media/training-illustration11.c02dff17.png";